import { render, staticRenderFns } from "./CompanyComponentBlurred.vue?vue&type=template&id=130608f2&scoped=true"
import script from "./CompanyComponentBlurred.vue?vue&type=script&lang=js"
export * from "./CompanyComponentBlurred.vue?vue&type=script&lang=js"
import style0 from "./CompanyComponentBlurred.vue?vue&type=style&index=0&id=130608f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130608f2",
  null
  
)

export default component.exports